const { cELM, unique } = require("../../utils");
const Chat = require("../../chat");
const TextInput = require("./text-input");

class SingleSelectOther {
  constructor(data) {
    this._data = data;
    this.options =  unique((this._data.values || "").split("|").filter(a => a.length > 0));
    this.element = cELM("div", "option-block");
    this.textInputEl = new TextInput(data, getLngTxt('input.placeholder.type'));
    this.textInputEl.element.classList.add("flex-row");
    this.createElement();
  }

  createElement() {
    const _self = this;
    _self.element.classList.remove('prevent-pointer-events');
    this.options.forEach(op => {
      op = op.trim();
      if (op.length === 0) return;
      if (op.toLowerCase().trim() == getLngTxt("button.other").toLowerCase().trim()) return;

      const _el = cELM("div", "option");

      _el.onclick = function(evt) {
        let data = (window.__FN_DATA_WRAPPER) ? window.__FN_DATA_WRAPPER(op) : op;

        data = (typeof data == 'string') 
            ? { text: data, id: _self._data.id }
            : { ...data, id: _self._data.id };

        Chat.default.send(data, null, _self.element);

        _self.element.classList.add('prevent-pointer-events'); //CA: To avoid multiple clicks while the answer it's being processed
      };

      _el.innerHTML = '<div class="option-text">' + op + "</div>";

      this.element.addELM(_el);
    });

    const _elOther = cELM("div", "option");
    _elOther.innerHTML = '<div class="option-text">'+getLngTxt("button.other")+'</div>';

    _elOther.onclick = function(evt) {
      _self.element.addBefore(_self.textInputEl);
      _self.element.parentNode.removeELM(_self.element);

      _self.textInputEl.element.parentNode.classList.remove("singleselectflex");
      _self.element = _self.textInputEl;
      _self.textInputEl.focus();
    };

    if (this.options.length > 0) {
      this.element.addELM(_elOther);
    } else {
      this.element.addELM(this.textInputEl);
      setTimeout(() => {
        _self.textInputEl.focus();
      }, 400);
    }

    return this.element;
  }

  getELM() {
    return this.element;
  }

  getHTML() {
    return this.element;
  }

  reset() {}

  focus() {}
}

module.exports = SingleSelectOther;
